export default "__VITE_ASSET__a6c1e4a8__"